export class RecordSoftDeletedException extends Error {
  constructor(id: number | string, isIndex = false) {
    super(RecordSoftDeletedException.createMessage(id, isIndex));
  }

  private static createMessage(id: number | string, isIndex: boolean): string {
    if (isIndex) {
      return `Cannot get record with Index '${id}' as it has been deleted.`;
    }
    return `Cannot get record with Id '${id}' as it has been deleted.`;
  }
}
